<template>
  <div style="padding: 20px; min-height: 630px; background-color: rgba(221, 225, 230, 1); border: solid 1px #ccc">
    <v-card v-if="list_access">
      <div class="row mt-0">
        <div class="col-md-12">
          <div class="col-md-12" style="background:white; elevation-0">
            <div class="row pt-5">
              <div class="col-md-3 pt-0">
                <v-menu
                  ref="desde_selected"
                  v-model="desde_selected_open"
                  :close-on-content-click="false"
                  :close-on-click="false"
                  :return-value.sync="desde_selected"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  clearable
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                  </template>
                  <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                    <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="col-md-3 pt-0">
                <v-menu
                  ref="hasta_selected"
                  v-model="hasta_selected_open"
                  :close-on-content-click="false"
                  :close-on-click="false"
                  :return-value.sync="hasta_selected"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  clearable
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                  </template>
                  <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="hasta_selected_open = false"> Cancel </v-btn>
                    <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="col-md-3 pt-0">
                <v-combobox v-model="emitter_selected" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Emisor" class="pt-0 mt-0" clearable></v-combobox>
              </div>

              <div class="col-md-10 pt-0">
                <label class="caption">Agrupar resultado por:</label>
                <v-radio-group class="mt-0" v-model="group_selected" row>
                  <v-radio label="Agrupar por producto" :value="1" color="primary"></v-radio>
                  <v-radio label="Agrupar por cliente" :value="2" color="primary"></v-radio>
                  <v-radio label="Agrupar por producto y cliente" :value="3" color="primary"></v-radio>
                  <v-radio label="Centro de Costo y Concepto" :value="5" color="primary"></v-radio>
                  <v-radio label="Item del comprobante" :value="4" color="primary"></v-radio>
                </v-radio-group>
              </div>

              <div class="col-md-2 text-end mt-2">
                <v-btn color="info" class="" @click="filter">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12" style="background:rgb(237,237,237); elevation-0">
        <div class="row">
          <div class="col-12">
            <!-- Botón para abrir el modal de filtros -->
            <v-btn color="info" text @click="openFilterModal" small>+ Agregar filtros adicionales</v-btn>

            <!-- Chips que muestran los filtros seleccionados -->
            <v-chip v-for="(filter, index) in selected_filters" :key="index" class="ml-2" close @click:close="removeFilter(index)"> {{ filter.label }}: {{ filter.value }} </v-chip>
          </div>
        </div>

        <v-dialog v-model="dialog_filters" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Filtros</span>
            </v-card-title>

            <v-card-text>
              <div class="row mt-4">
                <div class="col-md-12 pt-0">
                  <v-combobox
                    v-model="type_product_selected"
                    autocomplete="off"
                    data-vv-as="type_product_selected"
                    name="type_product_selected"
                    item-text="name"
                    item-value="id"
                    :items="product_types"
                    label="Tipo de producto"
                    multiple
                    small-chips
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-12 pt-0">
                  <v-combobox
                    v-model="salesman_selected"
                    autocomplete="off"
                    data-vv-as="salesman_selected"
                    name="salesman_selected"
                    item-text="name"
                    item-value="id"
                    :items="salesmans"
                    label="Vendedor"
                    multiple
                    small-chips
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-12 pt-0">
                  <v-combobox
                    v-model="client_selected"
                    autocomplete="off"
                    data-vv-as="client_selected"
                    name="client_selected"
                    item-text="name"
                    item-value="id"
                    :items="clients"
                    label="Cliente"
                    multiple
                    small-chips
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-12 pt-0">
                  <v-combobox
                    v-model="product_selected"
                    autocomplete="off"
                    data-vv-as="product_selected"
                    name="product_selected"
                    item-text="label"
                    item-value="id"
                    :items="products"
                    label="Producto"
                    multiple
                    small-chips
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-12 pt-0">
                  <v-combobox v-model="category_selected" autocomplete="off" item-text="name" item-value="id" :items="categories" label="Rubro de producto" multiple small-chips clearable></v-combobox>
                </div>
                <div class="col-md-12 pt-0">
                  <v-combobox
                    v-model="client_zone_selected"
                    autocomplete="off"
                    data-vv-as="client_zone_selected"
                    name="client_zone_selected"
                    item-text="name"
                    item-value="id"
                    :items="zones_client"
                    label="Zona"
                    multiple
                    small-chips
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-12 pt-0">
                  <v-autocomplete v-model="cost_center_selected" :items="costs_centers" item-text="name" item-value="id" return-object autocomplete="off" label="Centro de costos" multiple small-chips clearable></v-autocomplete>
                </div>
                <div class="col-md-12 pt-0">
                  <v-autocomplete v-model="concepto_selected" :items="conceptos" item-text="name" item-value="id" return-object autocomplete="off" label="Concepto" multiple small-chips clearable></v-autocomplete>
                </div>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- Botones para aplicar o cancelar filtros -->
              <v-btn color="error" text @click="closeFilterModal">Cancelar</v-btn>
              <v-btn color="success" text @click="filter">Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
    <v-card v-if="list_access" class="mt-3">
      <v-card-title>
        <v-btn color="blue-grey" class="mt-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
        <v-btn v-if="isCostCenterConceptoResult" color="grey darken-1" class="mt-3 ml-2" small outlined :disabled="loading || !list.length || buscando" @click="toggleAll">
          {{ allExpanded ? "Colapsar todo" : "Expandir todo" }}
        </v-btn>

        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>

      <v-alert v-if="hayOtraMoneda" dense text type="warning" class="mx-4 mb-2 text-caption">
        Incluye comprobantes en moneda extranjera: estos importes se suman sin convertir a pesos. Para ver cada importe con su moneda, agrupá por «Item del comprobante».
      </v-alert>

      <v-data-table
        class="tabla-ventas"
        :headers="headers"
        :items="tableItems"
        :search="search"
        :loading="loading"
        loading-text="Cargando..."
        :options="tableOptions"
        :hide-default-footer="isCostCenterConceptoResult"
        @pagination="updatePagination"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15, 50, -1],
        }"
      >
        <template v-slot:item="props">
          <tr>
            <td v-if="hasOwnProperty(props.item, 'cbte_fch')" class="text-no-wrap">{{ props.item.cbte_fch }}</td>
            <td v-if="hasOwnProperty(props.item, 'voucher_number_label')" class="text-no-wrap">{{ props.item.voucher_number_label }}</td>
            <td v-if="hasOwnProperty(props.item, 'client_name')">{{ props.item.client_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'client_type')">{{ props.item.client_type }}</td>
            <td v-if="hasOwnProperty(props.item, 'emitter_name')">{{ props.item.emitter_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'descripcion')">{{ props.item.descripcion }}</td>
            <td v-if="isProductCompany() && hasOwnProperty(props.item, 'product_name')">{{ props.item.product_name != null ? props.item.product_name : "-" }}</td>
            <td v-if="hasOwnProperty(props.item, 'cost_center_name')">{{ props.item.cost_center_name != null ? props.item.cost_center_name : "-" }}</td>
            <td v-if="hasOwnProperty(props.item, 'concepto_name')">{{ props.item.concepto_name != null ? props.item.concepto_name : "-" }}</td>
            <td v-if="hasOwnProperty(props.item, 'sku')">{{ props.item.sku }}</td>
            <td v-if="hasOwnProperty(props.item, 'name')">{{ props.item.name }}</td>
            <td v-if="hasOwnProperty(props.item, 'category')">{{ props.item.category }}</td>
            <td v-if="hasOwnProperty(props.item, 'subcategory')">{{ props.item.subcategory }}</td>
            <td v-if="hasOwnProperty(props.item, 'zone_name')">{{ props.item.zone_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'salesman_name')">{{ props.item.salesman_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'quantity')" class="text-right">{{ formatUtils.formatNumber(props.item.quantity) }}</td>
            <td v-if="hasOwnProperty(props.item, 'mon_name')" class="text-no-wrap">{{ props.item.mon_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'unit_price')" class="text-right text-no-wrap">{{ formatItemAmount(props.item.unit_price, props.item) }}</td>
            <td v-if="isProductCompany() && hasOwnProperty(props.item, 'total_weight')" class="text-right">{{ props.item.total_weight + props.item.weight_unit }}</td>
            <td v-if="hasOwnProperty(props.item, 'total_sin_iva')" class="text-right text-no-wrap">{{ hasOwnProperty(props.item, 'item_id') ? formatItemAmount(props.item.total_sin_iva, props.item) : formatUtils.formatPrice(props.item.total_sin_iva) }}</td>
            <td v-if="puede_reasignar && hasOwnProperty(props.item, 'item_id')" class="text-right col-reasignar">
              <v-tooltip v-if="puedeReasignarFila(props.item)" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="blue" :disabled="loading" @click="openReasignar(props.item)">account_tree</v-icon>
                </template>
                <span>Reasignar concepto y centro de costo</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
        <template v-slot:group="{ group, items }">
          <tr
            :key="'g-' + group"
            class="font-weight-bold"
            :class="{ 'grey lighten-4': isGroupOpen(group) }"
            :style="buscando ? '' : 'cursor:pointer'"
            :title="buscando ? 'Subtotal de los conceptos encontrados. Vaciá el buscador para plegar.' : null"
            @click="toggleGroup(group)"
          >
            <td>
              <div class="d-flex align-center">
                <v-btn icon x-small class="mr-1" :disabled="buscando" :aria-expanded="String(isGroupOpen(group))" :aria-label="(isGroupOpen(group) ? 'Colapsar ' : 'Expandir ') + items[0].cost_center_name" @click.stop="toggleGroup(group)">
                  <v-icon small>{{ isGroupOpen(group) ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                </v-btn>
                <span>{{ items[0].cost_center_name }}</span>
              </div>
            </td>
            <td></td>
            <td class="text-right text-no-wrap">{{ formatUtils.formatPrice(sumValues(items.map((i) => i.total_sin_iva))) }}</td>
          </tr>
          <template v-if="isGroupOpen(group)">
            <tr v-for="(item, index) in items" :key="'c-' + group + '-' + index">
              <td></td>
              <td>{{ item.concepto_name }}</td>
              <td class="text-right text-no-wrap">{{ formatUtils.formatPrice(item.total_sin_iva) }}</td>
            </tr>
          </template>
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:header.unit_price="{ header }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ header.text }}</span>
            </template>
            <span>Sin IVA y antes de descuentos</span>
          </v-tooltip>
        </template>
        <template v-slot:no-results>
          <div class="text-center grey--text pa-4">No hay resultados para «{{ search }}»</div>
        </template>
      </v-data-table>
    </v-card>
    <DialogReasignarConcepto
      :open="dialog_reasignar"
      :item="reasignar_item"
      :conceptos="conceptos_destino"
      :cost_centers="costs_centers"
      amount_label="Total S/IVA"
      @cancel="closeReasignar"
      @reasignado="onReasignado"
    />
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { formatUtils } from "@/libs/utils/formatUtils";
import { clientsService } from "@/libs/ws/clientsService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { salesmanService } from "@/libs/ws/salesmanService";

import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogReasignarConcepto from "@/components/DialogReasignarConcepto.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import CollapsibleGroupsMixin from "@/mixins/CollapsibleGroupsMixin.vue";
export default {
  components: { DialogReasignarConcepto },
  mixins: [GenericMixin, RolMixin, ExportMixin, SettingsMixin, CollapsibleGroupsMixin],
  data() {
    return {
      Constant: Constant,
      VOUCHER_STATE_CANCELED: 2, // VoucherAFIP::STATE_CANCELED (backend)
      formatUtils: formatUtils,
      service: generalService,
      page_title: "Ventas por producto",
      modal_title: "Ventas por producto",
      originalHeader: null,
      headers: [
        {
          text: "Fecha comprobante",
          align: "left",
          sortable: true,
          value: "cbte_fch",
          visible: false,
        },
        {
          text: "N° comprobante",
          align: "left",
          sortable: true,
          value: "voucher_number_label",
          visible: false,
        },
        {
          text: "Cliente",
          align: "left",
          sortable: true,
          value: "client_name",
          visible: false,
        },
        {
          text: "Tipo",
          align: "left",
          sortable: true,
          value: "client_type",
          visible: false,
        },
        {
          text: "Emisor",
          align: "left",
          sortable: true,
          value: "emitter_name",
          visible: false,
        },
        {
          text: "Descripcion",
          align: "left",
          sortable: true,
          value: "descripcion",
          visible: false,
        },
        {
          text: "Producto",
          align: "left",
          sortable: true,
          value: "product_name",
          visible: false,
        },
        {
          text: "SKU",
          align: "left",
          sortable: true,
          value: "sku",
          visible: false,
        },
        {
          text: "Producto",
          align: "left",
          sortable: true,
          value: "name",
          visible: false,
        },
        {
          text: "Rubro",
          align: "left",
          sortable: true,
          value: "category",
          visible: false,
        },
        {
          text: "Subrubro",
          align: "left",
          sortable: true,
          value: "subcategory",
          visible: false,
        },
        {
          text: "Centro de Costo",
          align: "left",
          sortable: true,
          value: "cost_center_name",
          visible: false,
        },
        {
          text: "Concepto",
          align: "left",
          sortable: true,
          value: "concepto_name",
          visible: false,
        },
        {
          text: "Zona",
          align: "left",
          sortable: true,
          value: "zone_name",
          visible: false,
        },
        {
          text: "Vendedor",
          align: "left",
          sortable: true,
          value: "salesman_name",
          visible: false,
        },
        {
          text: "Cantidad",
          align: "right",
          sortable: true,
          value: "quantity",
          visible: false,
        },
        {
          text: "Moneda",
          align: "left",
          sortable: true,
          value: "mon_name",
          visible: false,
        },
        {
          text: "Precio unitario",
          align: "right",
          sortable: true,
          value: "unit_price",
          visible: false,
        },
        {
          text: "Peso total",
          align: "right",
          sortable: true,
          value: "total_weight",
          visible: false,
        },
        { text: "Total S/IVA", value: "total_sin_iva", align: "right", visible: false },
        { text: "", align: "right", sortable: false, value: "reasignar", width: "48px", class: "col-reasignar", visible: false },
      ],
      list: [],
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      desde_selected_open: false,
      hasta_selected_open: false,
      group_cost_center_concepto: 5,
      default_group_selected: null,
      last_search_params: null,
      group_selected: 1,
      client_selected: [],
      category_selected: [],
      emitter_selected: null,
      salesman_selected: [],
      type_product_selected: [],
      product_selected: [],
      client_zone_selected: [],
      cost_center_selected: [],
      concepto_selected: [],
      emitters: [],
      clients: [],
      categories: [],
      salesmans: [],
      product_types: [],
      products: [],
      zones_client: [],
      costs_centers: [],
      conceptos: [],
      selected_filters: [],
      dialog_filters: false,
      dialog_reasignar: false,
      reasignar_item: {},
    };
  },
  computed: {
    isCostCenterConceptoResult() {
      return this.default_group_selected === this.group_cost_center_concepto;
    },
    tableItems() {
      if (!this.isCostCenterConceptoResult) return this.list;
      const keys = {};
      return this.list.map((row) => {
        const id = String(row.cost_center_id);
        if (!(id in keys)) keys[id] = Object.keys(keys).length + 1;
        return { ...row, group_key: keys[id] };
      });
    },
    puede_reasignar() {
      return this.getModuleAccess(Constant.SECTION_VOUCHERS, "list") && this.getModuleAccess(Constant.SECTION_VOUCHERS, "update");
    },
    // El backend rechaza conceptos de egreso para ventas; el combo de filtros sigue usando `conceptos`.
    conceptos_destino() {
      return this.conceptos.filter((c) => !c.tipo || c.tipo.id !== "E");
    },
    // El agrupado por ítem muestra cada importe con su moneda, por eso no lleva aviso.
    hayOtraMoneda() {
      return [1, 2, 3, this.group_cost_center_concepto].includes(this.default_group_selected) && this.list.some((row) => row.items_otra_moneda > 0);
    },
  },
  mounted() {
    this.originalHeader = JSON.parse(JSON.stringify(this.headers));
    this.setHeader(this.group_selected);
    this.loadList(this.service);
    this.loadClients();
    this.loadCategories();
    this.loadEmitters();
    this.loadSalesmans();
    this.loadProductType();
    this.loadProducts();
    this.loadZonesClient();
    this.loadCostsCenter();
    this.loadConceptos();
  },
  methods: {
    setHeader(group) {
      var Header_Options = {
        1: ["sku", "name", "category", "subcategory", "quantity", "total_weight", "total_sin_iva"],
        2: ["client_name", "client_type", "zone_name", "salesman_name", "total_sin_iva"],
        3: ["client_name", "sku", "name", "category", "subcategory", "quantity", "total_weight", "zone_name", "salesman_name", "total_sin_iva"],
        4: ["cbte_fch", "voucher_number_label", "client_name", "emitter_name", "descripcion", "product_name", "cost_center_name", "concepto_name", "quantity", "mon_name", "unit_price", "total_sin_iva", "reasignar"],
        [this.group_cost_center_concepto]: ["cost_center_name", "concepto_name", "total_sin_iva"],
      };

      var Header_Product_Company = ["total_weight", "product_name"];
      var visible = Header_Options[group] || [];

      this.headers = this.originalHeader.filter((header) => {
        if (!visible.includes(header.value)) {
          return false;
        }
        if (!this.isProductCompany() && Header_Product_Company.includes(header.value)) {
          return false;
        }
        if (header.value === "reasignar" && !this.puede_reasignar) {
          return false;
        }
        return true;
      });

      // Se asigna acá y no en `headers`: originalHeader se clona con JSON y descartaría la función.
      this.headers = this.headers.map((header) => (header.value === "cbte_fch" ? { ...header, sort: formatUtils.compareDateStrings } : header));

      if (group === this.group_cost_center_concepto) {
        this.headers = this.headers.map((header) => {
          if (header.value === "cost_center_name") return { ...header, width: "320px", sortable: false };
          if (header.value === "total_sin_iva") return { ...header, width: "180px" };
          return header;
        });
      }
    },
    // Los importes del ítem van en la moneda del comprobante, sin convertir.
    formatItemAmount(value, row) {
      return row.mon_id === "PES" ? formatUtils.formatPrice(value) : row.mon_name + " " + formatUtils.formatNumber(value);
    },
    puedeReasignarFila(row) {
      return row.state !== this.VOUCHER_STATE_CANCELED && !row.es_compensacion_rechazo && !row.nc_de_factura_anulada;
    },
    openReasignar(row) {
      this.reasignar_item = {
        item_type: "voucher",
        item_id: row.item_id,
        descripcion: [row.voucher_number_label, row.descripcion].filter(Boolean).join(" - "),
        concepto_name: row.concepto_name,
        cost_center: row.cost_center_name,
        amount: row.total_sin_iva,
        amount_display: this.formatItemAmount(row.total_sin_iva, row),
      };
      this.dialog_reasignar = true;
    },
    // No se limpia el item: el diálogo lo sigue mostrando durante el fade de cierre.
    closeReasignar() {
      this.dialog_reasignar = false;
    },
    onReasignado() {
      this.closeReasignar();
      // Recarga lo que está en pantalla, no los filtros que el usuario esté editando sin haber buscado.
      if (this.last_search_params) this.loadList(this.service, { ...this.last_search_params });
    },
    hasOwnProperty(obj, key) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return true;
      }
    },
    getFilterParams() {
      const param = {
        from: this.desde_selected,
        to: this.hasta_selected,
        client: this.client_selected.length ? this.client_selected.map((client) => client.id) : null,
        category: this.category_selected.length ? this.category_selected.map((category) => category.id) : null,
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
        salesman: this.salesman_selected.length ? this.salesman_selected.map((salesman) => salesman.id) : null,
        type_product: this.type_product_selected.length ? this.type_product_selected.map((type) => type.id) : null,
        product: this.product_selected.length ? this.product_selected.map((product) => product.id) : null,
        zone_client: this.client_zone_selected.length ? this.client_zone_selected.map((zone) => zone.id) : null,
        cost_center: this.cost_center_selected.length ? this.cost_center_selected.map((cc) => cc.id) : null,
        concepto: this.concepto_selected.length ? this.concepto_selected.map((c) => c.id) : null,
        group: this.group_selected,
      };

      this.selected_filters = [
        {
          label: "Tipo de producto",
          value: this.type_product_selected.length ? this.type_product_selected.map((type) => (type.name.length > 20 ? type.name.substring(0, 20) + "..." : type.name)).join(", ") : null,
        },
        {
          label: "Vendedor",
          value: this.salesman_selected.length ? this.salesman_selected.map((salesman) => (salesman.name.length > 20 ? salesman.name.substring(0, 20) + "..." : salesman.name)).join(", ") : null,
        },
        {
          label: "Cliente",
          value: this.client_selected.length ? this.client_selected.map((client) => (client.name.length > 20 ? client.name.substring(0, 20) + "..." : client.name)).join(", ") : null,
        },
        {
          label: "Producto",
          value: this.product_selected.length ? this.product_selected.map((product) => (product.name.length > 20 ? product.name.substring(0, 20) + "..." : product.name)).join(", ") : null,
        },
        {
          label: "Rubro de producto",
          value: this.category_selected.length ? this.category_selected.map((category) => (category.name.length > 20 ? category.name.substring(0, 20) + "..." : category.name)).join(", ") : null,
        },
        {
          label: "Zona cliente",
          value: this.client_zone_selected.length ? this.client_zone_selected.map((zone) => (zone.name.length > 20 ? zone.name.substring(0, 20) + "..." : zone.name)).join(", ") : null,
        },
        {
          label: "Centro de costos",
          value: this.cost_center_selected.length ? this.cost_center_selected.map((cc) => (cc.name.length > 20 ? cc.name.substring(0, 20) + "..." : cc.name)).join(", ") : null,
        },
        {
          label: "Concepto",
          value: this.concepto_selected.length ? this.concepto_selected.map((c) => (c.name.length > 20 ? c.name.substring(0, 20) + "..." : c.name)).join(", ") : null,
        },
      ].filter((filter) => filter.value);

      this.dialog_filters = false;

      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    openFilterModal() {
      this.dialog_filters = true;
    },
    closeFilterModal() {
      this.dialog_filters = false;
    },
    removeFilter(index) {
      const filtered = this.selected_filters[index];
      this.selected_filters.splice(index, 1);

      if (filtered.label === "Tipo de producto") {
        this.type_product_selected = [];
      } else if (filtered.label === "Vendedor") {
        this.salesman_selected = [];
      } else if (filtered.label === "Cliente") {
        this.client_selected = [];
      } else if (filtered.label === "Producto") {
        this.product_selected = [];
      } else if (filtered.label === "Rubro de producto") {
        this.category_selected = [];
      } else if (filtered.label === "Zona cliente") {
        this.client_zone_selected = [];
      } else if (filtered.label === "Centro de costos") {
        this.cost_center_selected = [];
      } else if (filtered.label === "Concepto") {
        this.concepto_selected = [];
      }

      this.filter();
    },
    loadSalesmans() {
      salesmanService
        .filter({ enabled: true })
        .then((response) => {
          this.salesmans = response.result;
        })
        .catch((e) => {});
    },
    loadEmitters() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result;
      });
    },
    loadClients() {
      clientsService.filterMinify().then((response) => {
        this.clients = response.result;
      });
    },
    loadCategories() {
      generalService.filter({}, Constant.SECTION_CATEGORIES).then((response) => {
        this.categories = response.result;
      });
    },
    loadProductType() {
      generalService.filter({}, Constant.SECTION_PRODUCT_TYPE).then((response) => {
        this.product_types = response.result;
      });
    },
    loadProducts() {
      generalService.filter({}, Constant.SECTION_PRODUCTS).then((response) => {
        this.products = response.result;
      });
    },
    loadZonesClient() {
      generalService.setSection(Constant.SECTION_CLIENT_ZONE);
      generalService
        .filter()
        .then((response) => {
          this.zones_client = response.result;
        })
        .catch((e) => {
          console.log("zones_client.filter error");
          console.log(e);
        });
    },
    loadCostsCenter() {
      generalService.filter({}, Constant.SECTION_COSTS_CENTERS).then((response) => {
        this.costs_centers = Array.isArray(response.result) ? response.result : [];
      });
    },
    loadConceptos() {
      generalService.filter({ enabled: "all" }, Constant.SECTION_CONCEPTOS).then((response) => {
        this.conceptos = Array.isArray(response.result) ? response.result : [];
      });
    },
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      service
        .query(param, Constant.SECTION_REPORTS + "/ventas-por-periodo")
        .then((response) => {
          this.default_group_selected = param.group;
          this.last_search_params = { ...param };
          this.setHeader(param.group);
          this.expanded_groups = [];
          this.list = Array.isArray(response.result) ? response.result : [];
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },
    exportFile() {
      var param = this.getFilterParams();
      param["export"] = true;
      this.exportExcel(Constant.SECTION_REPORTS + "/ventas-por-periodo", param, "Ventas-por-periodo.xlsx");
    },
  },
};
</script>

<style scoped>
/* La acción queda siempre a la vista aunque la tabla haga scroll horizontal. */
.tabla-ventas >>> .col-reasignar {
  position: sticky;
  right: 0;
  z-index: 1;
  background-color: white;
}
.search-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
}
</style>
